import React from 'react';
import MemberDetail from './index';

const MemberJourneyReport: React.FC = () => {
  return <MemberDetail section="journey-report" />;
};

MemberJourneyReport.displayName = 'MemberJourneyReport';
export default MemberJourneyReport;
